// extracted by mini-css-extract-plugin
export var description = "ticket-office-search-module--description--b8ddd";
export var map = "ticket-office-search-module--map--cdbe0";
export var searchForm = "ticket-office-search-module--searchForm--26ef3";
export var ticketOfficeList = "ticket-office-search-module--ticketOfficeList--74d15";
export var ticketOfficeSearch = "ticket-office-search-module--ticketOfficeSearch--0602e";
export var title = "ticket-office-search-module--title--10285";